export * from './get-card'


export const evervaultProxyUrl = import.meta.env.VITE_EVERVAULT_PROXY_URL